import React from 'react';
import MinAndMaxLength from './common/MinAndMaxLength';
import NumberColumnOptions from './common/NumberColumnOptions';

function NumberColumnConfig(props) {
    return (
        <React.Fragment>
            <MinAndMaxLength {...props} />
            <NumberColumnOptions {...props} />
        </React.Fragment>
    );
}

export default NumberColumnConfig;